var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"criteria_item"},[_c('input',{staticClass:"inpute_item",attrs:{"type":"Number"},domProps:{"value":_vm.value},on:{"input":_vm.inputHandler}})])}
var staticRenderFns = []

export { render, staticRenderFns }